import { Fragment, useState } from "react";
import { Transition, Menu, Dialog } from "@headlessui/react";
import Rive, { Alignment, Fit, Layout } from "@rive-app/react-canvas-lite";
import {
  ChevronDownIcon,
  GlobeAltIcon,
  ArrowRightOnRectangleIcon,
  DocumentTextIcon,
  TruckIcon,
  Bars3Icon,
  ComputerDesktopIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";

import * as React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { roles } from "utils/constant";
import { Input } from "components/Input";
import { Button } from "components/Button";
import { GetCommanWay, ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { useMutation, useQuery } from "@tanstack/react-query";
import { postLogout } from "service/api";
import UseToast from "utils/AfToast";
import { useAuthStore } from "store/auth";
import { log } from "node:console";
import { Img } from "components/Img";
import TotpSetup from "./TotpSetup";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  const [userDetails, setUserDetails] = useState<any>({});
  const [branchData, setBranchData] = useState<any>({});
  const [subbranchData, setSubbranchData] = useState<any>({});

  const [totpPopup, setTotpPopup] = useState<any>(false);
  const [changePassPopup, setChangePassPopup] = useState(false);
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const navigator = useNavigate();
  const { setToken, setUser, token, removeAll } = useAuthStore();

  const {
    mutate,
    isLoading,
    data: data_,
  } = useMutation(
    (data: any) =>
      ListCommanWay(
        data.url,
        {
          id: data.id,
        },
        {}
      ),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setBranchData(data.data.data[0]);
        }
      },
      onError: (data: any) => {},
    }
  );

  React.useEffect(() => {
    const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
      if (userD.state.user.branch_name) {
        mutate({
          type: "branch",
          url: "/admin/branch/list",
          id: userD.state.user.branch_name,
        });
      } else if (userD.state.user.subbranch) {
        mutate({
          type: "subbranch",
          url: "/admin/subbranch/list",
          id: userD.state.user.subbranch,
        });
      }
    }
  }, []);

  const THIRD_PARTY_PERMISSION = [""];

  const navigation: any = [
    ...(userDetails.roleName === roles.SUPER_ADMIN
      ? [
          {
            name: "ADMIN Master",
            current: false,
            children: [
              /*{ name: "Branch", to: "/master/branch/list" },
              { name: "Wallets", to: "/master/wallet/list" },*/
              { name: "Customer", to: "/master/customer/list" },
              { name: "Rate", to: "/master/rate/list" },
              /*{ name: "State", to: "/master/state/list" },*/
              { name: "City", to: "/master/city/list" },
              { name: "Pincode", to: "/master/pincode/list" },
              { name: "Branch", to: "/master/subbranch/list" },
              /*{ name: "Product", to: "/master/product/list" },
              { name: "Employee", to: "/master/agent/list" },*/
              { name: "Airfield Users", to: "/master/user/list?tp=0" },
              { name: "ThirdPart Users", to: "/master/user/list?tp=1" },
              { name: "Users Security", to: "/security/user/list" },
              { name: "Data Change", to: "/admin/data-change" },
              { name: "Geo Track", to: "/geo/list" },
            ],
          },
        ]
      : []),
    /*...(userDetails.roleName === roles.SUPER_ADMIN ||
    userDetails.roleName === roles.BRANCH_ADMIN ||
    userDetails.roleName === roles.SUBBRANCH_ADMIN
      ? [
          {
            name: "MASTER",
            icon: Bars3Icon,
            current: false,
            children: [{ name: "Customer", to: "/master/customer/list" }],
          },
        ]
      : []),*/

    ...(userDetails.roleName === roles.SUPER_ADMIN || userDetails.roleName === roles.MANAGER
      ? [
          {
            name: "Account",
            icon: Bars3Icon,
            current: false,
            children: [
              { name: "Vendor Master", to: "/master/vendor/list" },
              { name: "Vendor Payment", to: "/master/vendorpayment/list" },
              { name: "Expense Vouchures", to: "/vouchure/expense/list" },
              { name: "Travel Vouchures", to: "/billing/vouchure-gen" },
              { name: "Salary", to: "/master/salary/list" },
              { name: "Company Expense", to: "/master/companyexpense/list" },
              { name: "Expense Report", to: "/report/expense" },
            ],
          },
        ]
      : []),
    ...(userDetails.roleName === roles.SUPER_ADMIN ||
    userDetails.roleName === roles.BRANCH_ADMIN ||
    userDetails.roleName === roles.SUBBRANCH_ADMIN ||
    userDetails.roleName === roles.AGENT ||
    userDetails.roleName === roles.CUSTOMER_SERVICE
      ? [
          {
            name: "BOOKING",
            icon: TruckIcon,
            current: false,
            children: [
              /*{ name: "AWB List", to: "/awb/list" },*/

              /*...(userDetails.userType == 9 ? [] : [{ name: "Pickup Requests", to: "/topay-pickup/req" }]),*/
              ...(userDetails.userType == 9 ? [] : [{ name: "Topay Pickup", to: "/topay-pickup/add" }]),
              { name: "Book Domestic", to: "/booking/add" },
              { name: "Book International", to: "/booking/add-intl" },

              ...(userDetails.userType == 9
                ? []
                : [
                    { name: "Rate Calculator", to: "/rate/calculate" },
                    { name: "Intl. Rate Calculator", to: "/rate/intl-calculate" },
                  ]),
            ],
          },
          {
            name: "OPERATION",
            icon: TruckIcon,
            current: false,
            children: [
              ...(userDetails.userType == 9 || userDetails.userType == 4 ? [] : [{ name: "AWB Sticker", to: "/awb/generate" }]),
              ...(userDetails.userType == 9 ? [] : [{ name: "AWB Slip Generator", to: "/awb/open-slip" }]),
              { name: "Flight Schedule", to: "/report/flight" },

              { name: "Mother Bag Tally", to: "/mother_bag/add" },
              /*{ name: "List Mother Bag Tally", to: "/mother_bag/list" },*/

              { name: "Out Scan Motherbag", to: "/mother_bag/outscan" },
              { name: "In Scan Motherbag", to: "/mother_bag/inscan" },

              { name: "Generate DRS", to: "/drs/manage" },
              { name: "List  DRS", to: "/drs/list" },

              { name: "Send to Thirdparty", to: "/third-party/manage" },

              { name: "Update POD", to: "/pod/update" },
              { name: "Overedge", to: "/pod/overedge" },
            ],
          },
          {
            name: "REPORT",
            icon: TruckIcon,
            current: false,
            children: [
              { name: "Booking", to: "/report/booking" },

              ...(userDetails.roleName === roles.SUPER_ADMIN
                ? [
                    { name: "Vendor Master", to: "/master/vendor/list" },
                    { name: "Vendor Payment", to: "/master/vendorpayment/list" },
                  ]
                : []),

              ...(userDetails.userType == 9
                ? []
                : [
                    { name: "Cash Report", to: "/report/cash" },
                    { name: "Credit Report", to: "/report/credit" },
                    { name: "Invoice Report", to: "/report/invoice" },
                    { name: "Attendance", to: "/report/attendance" },
                    { name: "Delivery Report", to: "/report/emp-delivery" },
                    { name: "Expense Vouchure List", to: "/vouchure/expense/list" },
                    { name: userDetails.roleName === roles.AGENT ? "Travel Vouchure" : "Generate Vouchure", to: "/billing/vouchure-gen" },
                  ]),
              ...(userDetails.roleName === roles.AGENT && userDetails.userType != 9
                ? [{ name: "Travel Vouchure", to: "/billing/vouchure-gen" }]
                : []),
            ],
          },
        ]
      : []),
    ...(userDetails.roleName === roles.MIS_CREDIT_CASH || userDetails.roleName === roles.MANAGER
      ? [
          {
            name: "BOOKING",
            icon: TruckIcon,
            current: false,
            children: [{ name: "Topay Pickup", to: "/topay-pickup/add" }],
          },
        ]
      : []),

    ...(userDetails.roleName === roles.ACCOUNTANT
      ? [
          {
            name: "Report",
            icon: TruckIcon,
            current: false,
            children: [
              { name: "Expense Vouchure List", to: "/vouchure/expense/list" },
              { name: userDetails.roleName === roles.AGENT ? "Travel Vouchure" : "Generate Vouchure", to: "/billing/vouchure-gen" },
            ],
          },
        ]
      : []),
    ...(userDetails.roleName === roles.MANAGER
      ? [
          {
            name: "Report",
            icon: TruckIcon,
            current: false,
            children: [
              { name: "Booking", to: "/report/booking" },
              { name: "Cash Report", to: "/report/cash" },
              { name: "Attendance", to: "/report/attendance" },
              { name: "Expense Vouchure List", to: "/vouchure/expense/list" },
              { name: userDetails.roleName === roles.AGENT ? "Travel Vouchure" : "Generate Vouchure", to: "/billing/vouchure-gen" },
              { name: "Vendor Master", to: "/master/vendor/list" },
              { name: "Vendor Payment", to: "/master/vendorpayment/list" },
            ],
          },
        ]
      : []),

    ...(userDetails.roleName === roles.MIS_CREDIT_CASH
      ? [
          {
            name: "Report",
            icon: TruckIcon,
            current: false,
            children: [
              { name: "Booking", to: "/report/booking" },
              { name: "Cash Report", to: "/report/cash" },
              { name: "Credit Report", to: "/report/credit" },
              { name: "Invoice Report", to: "/report/invoice" },
              { name: "Attendance", to: "/report/attendance" },
              { name: "Expense Vouchure List", to: "/vouchure/expense/list" },
            ],
          },
        ]
      : []),
    /*...(userDetails.roleName === roles.SUPER_ADMIN || 
      userDetails.roleName === roles.ACCOUNTANT || 
      userDetails.roleName === roles.MANAGER
      ? [
          {
            name: "Billing",
            icon: Bars3Icon,
            current: false,
            children: [
              { name: userDetails.roleName === roles.AGENT ? "Travel Vouchure" : "Generate Vouchure", to: "/billing/vouchure-gen" },
            ],
          },
        ]
      : []),*/

    ...(userDetails.roleName === "CUSTOMER"
      ? [
          {
            name: "Book Domestic",
            icon: PlusIcon,
            current: false,
            to: "/booking/add",
          },
          {
            name: "Booking Report",
            icon: TruckIcon,
            current: false,
            to: "/customer-report/booking",
          },
        ]
      : []),
  ];

  const logout = () => {
    postLogout({ data: {}, headers: { Authorization: "Bearer " + token } })
      .then((res) => {
        UseToast("Logout Successfull", "success");
        localStorage.removeItem("af_token");
        removeAll();
        navigator("/login");
      })
      .catch((err) => {
        console.error(err);
        UseToast("Login Failed! Try Again", "error");
      });
  };

  const { mutate: mutateChangePass, isLoading: isChangePassLoading } = useMutation(
    (data: any) =>
      UpdateCommanWay({
        url: data.url,
        data: { oldPassword: oldPass, newPassword: newPass },
      }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          //setBranchData(data.data.data[0]);
          UseToast("Password Changed Successfully", "success");
          logout();
        } else {
          UseToast(data?.message || "Something went wrong", "error");
        }
      },
      onError: (data: any) => {
        UseToast(data?.message || "Something went wrong", "error");
      },
    }
  );

  const onChangePass = () => {
    if (newPass == "" || confirmPass == "" || oldPass == "") {
      UseToast("All fields are required", "error");
      return;
    }
    if (newPass != "" && newPass !== confirmPass) {
      UseToast("Password and Confirm Password does not match", "error");
      return;
    }
    if (newPass.length < 8) {
      UseToast("Password should be atleast 8 characters", "error");
      return;
    }
    mutateChangePass({
      type: "change_pass",
      url: "/admin/user/change-password",
    });
  };

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location: any = useLocation();
  const params = useParams();
  const id: string | undefined = params?.id;

  let pathName = location?.pathname;
  try {
    let id_: any = location?.state?.state;
    if (!id_) {
      id_ = location?.state?.id;
    }
    if (id_) {
      pathName = pathName?.replaceAll("/edit/" + id_, "");
      pathName = pathName?.replaceAll("/" + id_, "");
    }
  } catch (ignore) {}

  const sideNavigation = navigation.map((item) => {
    let isSelected: any =
      item?.children &&
      item?.children?.map((childItem) => {
        const baseNav = childItem?.to;
        if (baseNav === pathName) {
          return true;
        } else {
          return false;
        }
      });

    return (
      <div key={"main-" + item.name}>
        {changePassPopup && (
          <div className="absolute z-50 left-0 top-0 w-full h-full min-h-screen bg-black-900 bg-opacity-20 flex items-start justify-center">
            <div className="rounded-xl border-2 border-primary p-4 bg-white relative mt-24">
              <div className="flex items-center justify-between bg-primary text-white p-2 rounded-lg">
                <p>Change Password: </p>
                <button
                  className="px-1"
                  onClick={() => {
                    setChangePassPopup(false);
                  }}
                >
                  ✖
                </button>
              </div>

              <div className="flex flex-col gap-2 mt-4">
                <input
                  value={oldPass}
                  onChange={(e) => {
                    setOldPass(e.target.value);
                  }}
                  className="border focus:border-black-900 rounded-md"
                  type="password"
                  placeholder="Old Password"
                />
                <input
                  value={newPass}
                  onChange={(e) => {
                    setNewPass(e.target.value);
                  }}
                  className="border focus:border-black-900 rounded-md"
                  type="password"
                  placeholder="New Password"
                />
                <input
                  value={confirmPass}
                  onChange={(e) => {
                    setConfirmPass(e.target.value);
                  }}
                  className="border focus:border-black-900 rounded-md"
                  type="password"
                  placeholder="Confirm Password"
                />
                <Button
                  onClick={() => {
                    onChangePass();
                  }}
                  className="border bg-primary text-white py-2 rounded-md"
                >
                  Change
                </Button>
              </div>
            </div>
          </div>
        )}

        {!item.children ? (
          <div key={item.name}>
            <NavLink
              to={item?.to}
              onClick={() => setSidebarOpen(false)}
              key={"navlink" + item.name}
              className={(props) => {
                return classNames(
                  props?.isActive && "bg-grey_bg",
                  " justify-center rounded-md px-4 py-2 text-sm font-semibold font-quicksand   focus:outline-none  bg-[#ffffff] relative inline-block text-left mr-3"
                );
              }}
            >
              {item.name}
            </NavLink>
          </div>
        ) : (
          <Menu key={item.name} as="div" className="relative inline-block text-left mr-3">
            <div>
              <Menu.Button className="inline-flex w-full justify-center rounded-md px-4 py-2 text-sm font-semibold font-quicksand   focus:outline-none  bg-[#ffffff]">
                {item.iconn && <GlobeAltIcon className="mr-2 h-5 w-5" aria-hidden="true" />}
                {item.name}
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none left-0">
                {item.children.map((subItem) => {
                  return (
                    <Menu.Item key={item.name + subItem.name}>
                      {({ active }) => (
                        <Link
                          className={`${
                            active ? "bg-dark1 text-white" : "text-gray-900"
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm font-medium`}
                          to={subItem.to}
                        >
                          {subItem.name}
                        </Link>
                      )}
                    </Menu.Item>
                  );
                })}
              </Menu.Items>
            </Transition>
          </Menu>
        )}
      </div>
    );
  });

  const [trackValue, setTrackValue] = useState("");
  return (
    <div key={"Asd"} className={`${pathName?.includes("/drs/list") ? "print:hidden" : "print:hidden"}`}>
      {/* responsive */}
      {totpPopup && (
        <div className="absolute z-50 left-0 top-0 w-full h-full min-h-screen bg-black-900 bg-opacity-60 flex items-start justify-center">
          <div className="rounded-xl border-2 border-primary p-4 bg-white relative mt-24 min-w-96">
            <Button
              className="bg-red-600 px-4 py-2 rounded-md mb-4 text-white"
              onClick={() => {
                setTotpPopup(false);
              }}
            >
              Close
            </Button>
            <TotpSetup />
          </div>
        </div>
      )}

      <div className="border-b- p-1.5- bg-[#E4EBF5]">
        <div className="flex flex-grow blue-grad rounded-md- relative h-[60px] z-30">
          <div className="flex flex-shrink-0 items-center px-2">
            <Link to="/dashboard">
              <Img src={"/logo-white.png"} className="h-[24px] ml-auto" />
            </Link>
          </div>

          <nav className="flex flex-grow items-center flex-1 px-2 overflow-y-visible z-10 font-inter" aria-label="Sidebar">
            {sideNavigation}

            <div className="bg-[#E4EBF5] nym-shadow-2 flex gap-1 mr-3 p-1 rounded-md">
              <div className="border border-blue-600 rounded-md bg-white">
                <Input
                  type="text"
                  className="p-1"
                  placeholder="Track AWB"
                  value={trackValue}
                  onChange={(e) => {
                    setTrackValue(e);
                  }}
                />
              </div>
              <Button
                className="bg-blue-600 px-2 py-1 rounded-md text-white"
                onClick={() => {
                  if (trackValue.length < 10 && userDetails.roleName != "CUSTOMER") {
                    navigator("/pickup/tracking?awb=" + trackValue);
                  } else {
                    navigator((userDetails.roleName == "CUSTOMER" ? "/customer-pod/tracking?awb=" : "/pod/tracking?awb=") + trackValue);
                  }

                  setTrackValue("");
                }}
              >
                Track
              </Button>
            </div>
            <div>
              <Button
                onClick={() => logout()}
                className={
                  "flex items-center justify-center text-white font-medium rounded-full h-8 w-8 border-2 bg-red-600/60 border-red-600"
                }
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#ffffff " className="size-4">
                  <path
                    fillRule="evenodd"
                    d="M8 1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5A.75.75 0 0 1 8 1ZM4.11 3.05a.75.75 0 0 1 0 1.06 5.5 5.5 0 1 0 7.78 0 .75.75 0 0 1 1.06-1.06 7 7 0 1 1-9.9 0 .75.75 0 0 1 1.06 0Z"
                    clipRule="evenodd"
                  />
                </svg>
              </Button>
            </div>
          </nav>
          <div className="flex flex-col items-center justify-end px-2 my-2">
            <div className="text-right">
              <Menu as="div" className="relative inline-block text-left z-20">
                <div>
                  <Menu.Button className="inline-flex w-full justify-center rounded-md px-4 bg-[#E4EBF5] text-sm font-medium">
                    {userDetails.name || userDetails.sh || userDetails.username || "-"}
                    <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5 hover:text-blue-500" aria-hidden="true" />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                    <div className="px-1 py-1 ">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={() => {
                              setChangePassPopup(true);
                            }}
                            className={`${
                              active ? "bg-primary text-white" : "text-gray-900"
                            } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                          >
                            Change Password
                          </button>
                        )}
                      </Menu.Item>

                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={() => {
                              setTotpPopup(true);
                            }}
                            className={`${
                              active ? "bg-primary text-white" : "text-gray-900"
                            } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                          >
                            Setup Authenticator
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>

            <div className="flex">
              <small className="text-white font-medium font-inter">
                {userDetails.role_name == 1
                  ? "Super Admin"
                  : userDetails.role_name == 2
                  ? "Branch Admin"
                  : userDetails.role_name == 3
                  ? "Subbranch Admin"
                  : userDetails.role_name == 4
                  ? "Agent"
                  : userDetails.role_name == 5
                  ? "Accountant"
                  : userDetails.role_name == 8
                  ? "CS"
                  : userDetails.role_name == 9
                  ? "Manager"
                  : userDetails.role_name == 10
                  ? "MIS"
                  : "Customer"}
              </small>
              <small className="text-white ml-1">
                {branchData.name && `- ${branchData.name}`}
                {branchData.branch_code && `- ${branchData.branch_code}`}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
